import React from 'react';

import { EMPTY_STOPWATCH, stopwatchClock } from '../stopwatch';
import useStopwatch from '../useStopwatch';
import { Leds } from './Scoreboard';

import './Scoreboard.css';

/**
 * The stopwatch of the stage: a board like the scoreboard's, with the minutes and seconds in
 * LEDs, counting up from zero. The admin panel starts it, pauses it and resets it; every phone
 * and the screen of the event show the same. Next to the scoreboard when both are showing.
 */
const Stopwatch = ({ stopwatch = EMPTY_STOPWATCH }) => {
  const seconds = useStopwatch(stopwatch);
  const state = stopwatch.running ? 'En marcha' : seconds > 0 ? 'En pausa' : 'En cero';

  return (
    <div className={`stopwatch${seconds >= 6000 ? ' stopwatch--wide' : ''}`} role='group' aria-label='Cronómetro'>
      <div className='stopwatch__title' aria-hidden='true'>
        Cronómetro
      </div>
      <div className='stopwatch__time'>
        <Leds text={stopwatchClock(seconds)} label={`Cronómetro: ${stopwatchClock(seconds)}`} role='timer' className='stopwatch__clock' />
      </div>
      <div className={`stopwatch__state${stopwatch.running ? ' stopwatch__state--running' : ''}`}>{state}</div>
    </div>
  );
};

export default Stopwatch;
